import React from 'react';
import { io, type Socket } from 'socket.io-client';

export const socket: Socket = io(process.env.REACT_APP_SOCKET_SERVER, {
    auth: {
        jwt: localStorage.getItem('token')
            ? `Bearer ${localStorage.getItem('token')}`
            : '',
    },
});
export const SocketContext = React.createContext(socket);
